import Vue from 'vue'
import VueRouter from 'vue-router'

// import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import ability from '@/libs/acl/ability'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    ...pages,
    {
      path: '/*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  const userLevels = [
    { userLevel: 0, userGroup: 'nonuser' },
    { userLevel: 1, userGroup: 'user' },
    { userLevel: 2, userGroup: 'poweruser' },
    { userLevel: 3, userGroup: 'admin' },
    { userLevel: 4, userGroup: 'superadmin' },
  ]

  let currentUserLevel = 0
  if (isLoggedIn) {
    currentUserLevel = userLevels.find(x => x.userGroup === ability.j[0].subject).userLevel
  }

  const canNavigate = to.matched.some(route => currentUserLevel >= route.meta.level)

  if (!canNavigate) {
    if (!isLoggedIn) return next({ name: 'auth-login' })
    return next({ name: 'misc-not-authorized' })
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
